import { Button } from '@carto/meridian-ds/components'
import { Box } from '@mui/material'
import LoadingContent from 'features/common/ui/Loaders/LoadingContent'
import { ReactNode, useCallback, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { redirectToAccounts } from 'features/auth-redirect/api/authenticationUtils'
import { ResourceType } from 'features/common'
import ErrorPage from 'features/errors/ui/ErrorPage'
import Prompt from './Prompt'

interface AuthenticationPromptProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryResult: any
  resourceType: ResourceType
  children: ReactNode
  logoPositive?: boolean
}

function AuthenticationPrompt({ queryResult, resourceType, logoPositive, children }: AuthenticationPromptProps) {
  const { data, isLoading, error } = queryResult
  const autoRedirect = data?.autoRedirect

  const doLogin = useCallback(() => {
    if (!data) return

    redirectToAccounts(data.login || data.url, resourceType)
  }, [data, resourceType])

  useEffect(() => {
    if (autoRedirect) {
      doLogin()
    }
  }, [autoRedirect, doLogin, error])

  const doSignup = () => {
    if (!data) return

    redirectToAccounts(data.signup, resourceType)
  }

  if (isLoading || autoRedirect) {
    return <LoadingContent />
  }

  if (error) {
    return <ErrorPage code={error.status} />
  }

  return (
    <Prompt isLoading={isLoading} error={error} logoPositive={logoPositive}>
      <Box flex={1}>{children}</Box>
      <Box p={2} textAlign="right">
        <Button onClick={doLogin}>
          <FormattedMessage id="common.button.login" />
        </Button>
        <Button variant="contained" onClick={doSignup}>
          <FormattedMessage id="common.button.signup" />
        </Button>
      </Box>
    </Prompt>
  )
}

export default AuthenticationPrompt
